<template>
    <div id="report-ticket">
        <div class="overall-content">
            <div class="chart-container">
                <div class="chart-section">
                    <h2>{{ $t("report.ticketCountByUser") }}</h2>
                    <TicketDistributionsByUser :filters="filters" :loading="loading" :data="data.byUser" />
                </div>
                <a-divider />
                <div class="chart-section">
                    <h2>{{ $t("report.ticketCountByStatus") }}</h2>
                    <TicketDistributionsByStatus :filters="filters" :loading="loading" :data="data.byStatus" />
                </div>
                <a-divider />
                <div class="chart-section">
                    <h2>{{ $t("report.ticketCountByStatus") }}</h2>
                    <TicketCountTimeSeriesChart :filters="filters" :loading="loading" :data="data.timeSeries" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import log2 from "../../../utils/log2";
import moment from "moment";
import { REPORT_API } from "../../../api/statistics";
import TicketDistributionsByUser from "./TicketDistributionsByUser.vue";
import TicketDistributionsByStatus from "./TicketDistributionsByStatus.vue";
import TicketCountTimeSeriesChart from "./TicketCountTimeSeriesChart.vue";

// ticket durumlarına göre pasta grafiği yaoılmalıs
const log = log2("ReportTicket");
export default {
    name: "ReportTicket",
    components: { TicketCountTimeSeriesChart, TicketDistributionsByStatus, TicketDistributionsByUser },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            loading: true,
            data: {
                byUser: [],
                byStatus: {},
                timeSeries: {},
            },
        };
    },

    methods: {
        async fetch() {
            log("fetchData", this.filters);
            REPORT_API.ticketDistributionsAll(this.filters)
                .then((res) => {
                    log("ticketDistributionsAll data fetched", res);
                    this.data = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#report-ticket {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .md-progress-bar {
        position: absolute;
        top: 0;
        width: 100%;
        margin-left: -10px;
    }

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .overall-content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        min-height: 100vh;
        position: relative;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .chart-section {
                display: flex;
                flex-direction: column;
                gap: 10px;

                h2 {
                    text-align: center;
                    font-weight: 700;
                    font-size: 40px;
                }
            }

            .header {
                width: 100%;
            }

            .chart {
                max-width: 1050px;
            }
        }
    }
}
</style>
